import uniq from 'lodash/uniq'
import get from 'lodash/get'
import { NONE, USER_CLUSTER } from '@/scripts/constants/early-access'
import axios from 'axios'
import qs from 'qs'
import { Cookies } from '../cookies'
import wcs from '.'

export interface WcsUserData {
  name: string
  email: string
  welcomMsg: string
  logged: boolean
  type: 'G' | 'R'
}
export class WcsUser {
  static getUserData = async (): Promise<WcsUserData> => {
    const user = await axios.get(wcs.getEndPoint('user'))
    localStorage.setItem('myAccount', JSON.stringify(user))
    return user.data
  }

  static areSomeValuesInsideEarlyAccessCookie = (values: string[]) => {
    const { earlyAccess } = wcs.getStoreConfig()
    const earlyAccessCookieValues = earlyAccess?.cookie?.split(',')
    return earlyAccessCookieValues.some((value) => values.includes(value))
  }

  static isEarlyAccessActivityInUserClusterCookie = () => {
    return WcsUser.areSomeValuesInsideEarlyAccessCookie(WcsUser.getUserClusterFromCookie())
  }

  static getUserClusterFromCookie = () => {
    const userClusterCookie = Cookies.get(USER_CLUSTER)
    return userClusterCookie ? userClusterCookie.split(',') : [NONE]
  }

  static getUserClusterFromWcs = () => {
    const { earlyAccess } = wcs.getStoreConfig()
    return earlyAccess?.user_cluster ? earlyAccess.user_cluster?.split(',') : [NONE]
  }

  static getUserClusterPromoFromUrl = () => {
    const locationSearch = `${window?.location?.search}`
    const queryParams = qs.parse(locationSearch.replace('?', ''))
    const promo = get(queryParams, 'promo', NONE) as string

    return Array.isArray(promo) ? promo : [promo]
  }

  static writeUserClusterCookie = (values: string) => {
    const normalizedValues = values.split(',').sort()
    const doesCookieExist = !!Cookies.get(USER_CLUSTER)

    if (doesCookieExist) {
      const userClusterCookie = WcsUser.getUserClusterFromCookie().filter(
        (cluster: string) => cluster !== NONE
      )

      userClusterCookie.push(...normalizedValues)

      const uniqueUserCluster = uniq(userClusterCookie)
      Cookies.set(USER_CLUSTER, uniqueUserCluster.join(','))
    } else {
      Cookies.set(USER_CLUSTER, normalizedValues.join(','))
    }
  }

  static getMergedUserCluster = (): string[] => {
    const userClusterFromCookie = WcsUser.getUserClusterFromCookie()
    const userClusterFromWcs = WcsUser.getUserClusterFromWcs()
    const mergedUserCluster = uniq([...userClusterFromCookie, ...userClusterFromWcs])
      .filter((cluster: string) => cluster && cluster !== NONE)
      .sort()

    return mergedUserCluster
  }
}
